import { Alert, AlertTitle } from '@material-ui/lab';
import React, { useEffect } from 'react';
import './Contact.css';
import ContactForm from './ContactForm';
import { useHistory } from 'react-router-dom';
import { sponsorsData } from './Products';
import { Helmet } from 'react-helmet';
import HomeIcon from '@material-ui/icons/Home';
import PhoneIcon from '@material-ui/icons/Phone';
import EmailIcon from '@material-ui/icons/Email';

function Contact() {
    const history = useHistory();

    useEffect(() => {
        history.push('/contact');
    }, []);

    return (
        <>
            <div className="container-fluid contact mt-3">
                <Helmet>
                    <meta name="description" content="Please contact us using this form if you face any problem. Our team will help you in any case..." />
                    <title>Contact | Kaipsool Pharmatech</title>
                </Helmet>
                <div className="row mt-5 mb-5">
                    <div className="col-lg-10 col-md-10 col-sm-12 mx-auto">
                        <div className="row">
                            <div className="col-lg-10 col-md-10 col-sm-12 mx-auto mt-1">
                                <Alert severity="info">
                                    If you have any questions or need further assistance related to our platform or event tickets, please don't hesitate to contact us at hello@kaipsool.com <br /><br />
                                    Thank you for using Kaipsool Pharmatech. We are here to provide you with valuable information and a seamless experience for your pharmaceutical and healthcare needs.
                                </Alert>
                            </div>

                            <div className="col-lg-10 col-md-10 col-sm-12 mx-auto mt-1">
                                <div className="row">
                                    <div className="col-md-5 mt-2">
                                        <div className="contact-info contactForm">
                                            <div className="contact-info-item">
                                                <div className="contact-info-icon">
                                                    <HomeIcon />
                                                </div>
                                                
                                                <div className="contact-info-content">
                                                    <h4>Address</h4>
                                                    <p>Kaipsool Pharmatech<br/>  Agamkuan, Chhoti-Pahari,<br /> Patna-800026,</p>
                                                </div>
                                            </div>
                                            
                                            <div className="contact-info-item">
                                                <div className="contact-info-icon">
                                                    <PhoneIcon />
                                                </div>
                                                
                                                <div className="contact-info-content">
                                                    <h4>Phone</h4>
                                                    <p>+91 9122249915</p>
                                                </div>
                                            </div>
                                            
                                            <div className="contact-info-item">
                                                <div className="contact-info-icon">
                                                    <EmailIcon />
                                                </div>
                                                
                                                <div className="contact-info-content">
                                                    <h4>Email</h4>
                                                    <p>hello@butamepharma.com</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-lg-7 col-md-7 col-sm-10">
                                        <ContactForm />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default Contact
